import { optionalProps, pprops } from '@frontend/sports/common/core/utils/redux';
import { createAction, props } from '@ngrx/store';
import { RewardTokenType } from 'packages/sports/web/app/src/tokens-base/token-base.models';

import BetslipActions from '../../base/store/actions';
import { BetStationFreeBetToken, IRewardToken, IRewardTokenSelection, RewardTokenContext } from './reward-tokens.model';
import { IRewardTokenEligibility, ITokenRecoveryState, ITokenStoreState } from './state';

export interface ActionWithTracking {
    trackingSource?: Record<string, string>;
    type: string;
}

export interface TokenDialogClosedProps {
    closeButtonClicked?: boolean;
    tokenContext?: RewardTokenContext;
}

export interface TokenInfoOverlayTabClickedProps {
    isAccaBoost: boolean;
}

export interface TokenInfoOverlayHiddenProps {
    okButtonClicked?: boolean;
    linkClicked?: boolean;
}

export class RewardTokensActions {
    static readonly ACTION_SCHEMA = `${BetslipActions.ACTION_SCHEMA}/reward-tokens`;

    private static readonly SET_TOKENS = `${RewardTokensActions.ACTION_SCHEMA}/SET_TOKENS`;
    private static readonly SET_TOKEN = `${RewardTokensActions.ACTION_SCHEMA}/SET_TOKEN`;
    private static readonly ADD_TOKENS = `${RewardTokensActions.ACTION_SCHEMA}/ADD_TOKENS`;
    private static readonly REMOVE_TOKENS_BY_ID = `${RewardTokensActions.ACTION_SCHEMA}/REMOVE_TOKENS_BY_ID`;
    private static readonly REMOVE_SELECTED_TOKENS = `${RewardTokensActions.ACTION_SCHEMA}/REMOVE_SELECTED_TOKENS`;
    private static readonly REMOVE_TOKENS_OF_TYPE = `${RewardTokensActions.ACTION_SCHEMA}/REMOVE_TOKENS_OF_TYPE`;
    private static readonly SET_COMBO_BET_ELIGIBILITY = `${RewardTokensActions.ACTION_SCHEMA}/SET_COMBO_BET_ELIGIBILITY`;
    private static readonly CHECK_ACCA_BOOST_ELIGIBILITY = `${RewardTokensActions.ACTION_SCHEMA}/CHECK_ACCA_BOOST_ELIGIBILITY`;
    private static readonly SET_TEASER_BET_ELIGIBILITY = `${RewardTokensActions.ACTION_SCHEMA}/SET_TEASER_BET_ELIGIBILITY`;
    private static readonly SET_SINGLE_BET_ELIGIBILITIES = `${RewardTokensActions.ACTION_SCHEMA}/SET_SINGLE_BET_ELIGIBILITIES`;
    private static readonly SET_BET_BETBUILDER_ELIGIBILITIES = `${RewardTokensActions.ACTION_SCHEMA}/SET_BET_BETBUILDER_ELIGIBILITIES`;
    private static readonly NOTIFY_ELIGIBILITY_UPDATED = `${RewardTokensActions.ACTION_SCHEMA}/NOTIFY_ELIGIBILITY_UPDATED`;

    private static readonly SET_BOG_ELIGIBILITY = `${RewardTokensActions.ACTION_SCHEMA}/SET_BOG_ELIGIBILITY`;
    private static readonly CLEAR_BOG_TOKENS = `${RewardTokensActions.ACTION_SCHEMA}/CLEAR_BOG_TOKENS`;
    private static readonly CLEAR_EDS_TOKENS = `${RewardTokensActions.ACTION_SCHEMA}/CLEAR_EDS_TOKENS`;
    private static readonly CLEAR_ACCA_BOOST_TOKENS = `${RewardTokensActions.ACTION_SCHEMA}/CLEAR_ACCA_BOOST_TOKENS`;
    private static readonly SELECT_BOG_TOKEN = `${RewardTokensActions.ACTION_SCHEMA}/SELECT_BOG_TOKEN`;
    private static readonly SET_BETSTATION_FREEBET_ELIGIBILITY = `${RewardTokensActions.ACTION_SCHEMA}/SET_BETSTATION_FREEBET_ELIGIBILITY`;
    private static readonly SELECT_BETSTATION_FREEBET_TOKEN = `${RewardTokensActions.ACTION_SCHEMA}/SELECT_BETSTATION_FREEBET_TOKEN`;
    private static readonly CHECK_ELIGIBILITY = `${RewardTokensActions.ACTION_SCHEMA}/CHECK_ELIGIBILITY`;
    private static readonly SET_EDS_ELIGIBILITY = `${RewardTokensActions.ACTION_SCHEMA}/SET_EDS_ELIGIBILITY`;
    private static readonly SELECT_EDS_TOKENS = `${RewardTokensActions.ACTION_SCHEMA}/SELECT_EDS_TOKENS`;

    private static readonly SELECT_TOKEN = `${RewardTokensActions.ACTION_SCHEMA}/SELECT_TOKEN`;
    private static readonly TOGGLE_TOKEN = `${RewardTokensActions.ACTION_SCHEMA}/TOGGLE_TOKEN`;
    private static readonly SELECT_SINGLE_TOKEN = `${RewardTokensActions.ACTION_SCHEMA}/SELECT_SINGLE_TOKEN`;
    private static readonly DESELECT_TOKEN = `${RewardTokensActions.ACTION_SCHEMA}/DESELECT_TOKEN`;
    private static readonly DESELECT_ALL_TOKEN = `${RewardTokensActions.ACTION_SCHEMA}/DESELECT_ALL_TOKEN`;
    private static readonly DESELECT_ACCA_BOOST_TOKEN = `${RewardTokensActions.ACTION_SCHEMA}/DESELECT_ACCA_BOOST_TOKEN`;
    private static readonly DESELECT_EDS_TOKENS = `${RewardTokensActions.ACTION_SCHEMA}/DESELECT_EDS_TOKENS`;
    private static readonly OPEN_DIALOG = `${RewardTokensActions.ACTION_SCHEMA}/OPEN_DIALOG`;
    private static readonly CLOSE_DIALOG = `${RewardTokensActions.ACTION_SCHEMA}/CLOSE_DIALOG`;
    private static readonly CLEAR_STATE = `${RewardTokensActions.ACTION_SCHEMA}/CLEAR_STATE`;
    private static readonly SET_BETSTATION_FREEBET_TOKEN = `${RewardTokensActions.ACTION_SCHEMA}/SET_BETSTATION_FREEBET_TOKEN`;
    private static readonly REMOVE_BETSTATION_FREEBET_TOKEN = `${RewardTokensActions.ACTION_SCHEMA}/REMOVE_BETSTATION_FREEBET_TOKEN`;
    private static readonly SHOW_ONBOARDING = `${RewardTokensActions.ACTION_SCHEMA}/SHOW_ONBOARDING`;
    private static readonly HIDE_ONBOARDING = `${RewardTokensActions.ACTION_SCHEMA}/HIDE_ONBOARDING`;
    private static readonly HIDE_ACQUISITION_ONBOARDING = `${RewardTokensActions.ACTION_SCHEMA}/HIDE_ACQUISITION_ONBOARDING`;
    private static readonly SHOW_OVERLAY_INFO = `${RewardTokensActions.ACTION_SCHEMA}/SHOW_OVERLAY_INFO`;
    private static readonly OVERLAY_TAB_CLICKED = `${RewardTokensActions.ACTION_SCHEMA}/OVERLAY_INFO_TAB_CLICKED`;
    private static readonly HIDE_OVERLAY_INFO = `${RewardTokensActions.ACTION_SCHEMA}/HIDE_OVERLAY_INFO`;
    private static readonly BANNER_CLICK = `${RewardTokensActions.ACTION_SCHEMA}/BANNER_CLICK`;
    private static readonly REFRESH = `${RewardTokensActions.ACTION_SCHEMA}/REFRESH`;
    private static readonly REFRESH_POST_PLACEMENT = `${RewardTokensActions.ACTION_SCHEMA}/REFRESH_POST_PLACEMENT`;
    private static readonly BET_STATION_CLEAR_STORAGE = `${RewardTokensActions.ACTION_SCHEMA}/BET_STATION_CLEAR_STORAGE`;
    private static readonly DESELECT_NON_REUSABLE_TOKENS = `${RewardTokensActions.ACTION_SCHEMA}/DESELECT_NON_REUSABLE_TOKENS`;
    private static readonly DESELECT_TOKEN_FOR_CONTEXT = `${RewardTokensActions.ACTION_SCHEMA}/DESELECT_TOKEN_FOR_CONTEXT`;
    private static readonly DESELECT_TOKENS_FROM_TAB_SWITCH = `${RewardTokensActions.ACTION_SCHEMA}/DESELECT_TOKENS_FROM_TAB_SWITCH`;
    private static readonly STORE_RECOVERABLE_TOKENS = `${RewardTokensActions.ACTION_SCHEMA}/STORE_RECOVERABLE_TOKENS`;
    private static readonly RECOVER_TOKEN = `${RewardTokensActions.ACTION_SCHEMA}/RECOVER_TOKEN`;
    private static readonly REMOVE_RECOVERABLE_TOKEN_FOR_CONTEXT = `${RewardTokensActions.ACTION_SCHEMA}/REMOVE_RECOVERABLE_TOKEN_FOR_CONTEXT`;
    private static readonly CLEAR_RECOVERABLE_TOKENS = `${RewardTokensActions.ACTION_SCHEMA}/CLEAR_RECOVERABLE_TOKENS`;
    private static readonly CHECK_HAS_ACQUISITION_REWARD_TOKEN = `${RewardTokensActions.ACTION_SCHEMA}/CHECK_HAS_ACQUISITION_REWARD_TOKEN`;
    private static readonly AUTO_APPLY_ACQUISITION_REWARD_TOKEN = `${RewardTokensActions.ACTION_SCHEMA}/AUTO_APPLY_ACQUISITION_REWARD_TOKEN`;
    private static readonly TRIGGER_ACCABOOST_REFRESH = `${RewardTokensActions.ACTION_SCHEMA}/TRIGGER_ACCABOOST_REFRESH`;

    static setTokens = createAction(RewardTokensActions.SET_TOKENS, pprops<IRewardToken[]>());
    static setToken = createAction(RewardTokensActions.SET_TOKEN, pprops<IRewardToken>());
    static addTokens = createAction(RewardTokensActions.ADD_TOKENS, pprops<IRewardToken[]>());
    static removeTokensById = createAction(RewardTokensActions.REMOVE_TOKENS_BY_ID, props<{ userTokenIds: string[] }>());
    static removeSelectedTokens = createAction(RewardTokensActions.REMOVE_SELECTED_TOKENS);
    static removeTokensByType = createAction(RewardTokensActions.REMOVE_TOKENS_OF_TYPE, pprops<RewardTokenType>());

    static notifyEligibilityUpdated = createAction(RewardTokensActions.NOTIFY_ELIGIBILITY_UPDATED);

    // BETSTATION exclusive
    static clearBogTokens = createAction(RewardTokensActions.CLEAR_BOG_TOKENS);
    static clearEdsTokens = createAction(RewardTokensActions.CLEAR_EDS_TOKENS);
    static clearAccaBoostTokens = createAction(RewardTokensActions.CLEAR_ACCA_BOOST_TOKENS);

    static setBogEligibility = createAction(RewardTokensActions.SET_BOG_ELIGIBILITY, pprops<IRewardTokenEligibility | null>());
    static selectBogToken = createAction(RewardTokensActions.SELECT_BOG_TOKEN, pprops<{ tokenId: string | null }>());
    static setBetstationFreeBetToken = createAction(RewardTokensActions.SET_BETSTATION_FREEBET_TOKEN, pprops<BetStationFreeBetToken>());
    static removeBetstationFreeBetToken = createAction(RewardTokensActions.REMOVE_BETSTATION_FREEBET_TOKEN);
    static setBetStationFreeBetEligibility = createAction(
        RewardTokensActions.SET_BETSTATION_FREEBET_ELIGIBILITY,
        pprops<IRewardTokenEligibility | null>(),
    );

    static deselectAccaBoostToken = createAction(RewardTokensActions.DESELECT_ACCA_BOOST_TOKEN);
    static deselectEdsTokens = createAction(RewardTokensActions.DESELECT_EDS_TOKENS);
    static selectBetStationFreeBetToken = createAction(RewardTokensActions.SELECT_BETSTATION_FREEBET_TOKEN, pprops<{ tokenId: string | null }>());
    static selectEdsTokens = createAction(RewardTokensActions.SELECT_EDS_TOKENS, pprops<{ tokenIds: string[] }>());
    static setEdsEligibility = createAction(RewardTokensActions.SET_EDS_ELIGIBILITY, pprops<IRewardTokenEligibility[]>());

    static checkEligibility = createAction(RewardTokensActions.CHECK_ELIGIBILITY);

    static setComboBetEligibility = createAction(RewardTokensActions.SET_COMBO_BET_ELIGIBILITY, pprops<IRewardTokenEligibility[]>());
    static checkAccaBoostEligibility = createAction(RewardTokensActions.CHECK_ACCA_BOOST_ELIGIBILITY);
    static setTeaserBetEligibility = createAction(RewardTokensActions.SET_TEASER_BET_ELIGIBILITY, pprops<IRewardTokenEligibility[]>());
    static setSingleBetEligibilies = createAction(
        RewardTokensActions.SET_SINGLE_BET_ELIGIBILITIES,
        pprops<
            {
                pickId: string;
                eligibility: IRewardTokenEligibility[];
            }[]
        >(),
    );

    static setBetBuilderEligibilities = createAction(
        RewardTokensActions.SET_BET_BETBUILDER_ELIGIBILITIES,
        pprops<
            {
                pickId: string;
                eligibility: IRewardTokenEligibility[];
            }[]
        >(),
    );

    static storeRecoverableTokens = createAction(RewardTokensActions.STORE_RECOVERABLE_TOKENS, pprops<ITokenRecoveryState[]>());
    static selectToken = createAction(RewardTokensActions.SELECT_TOKEN, pprops<IRewardTokenSelection>());

    static toggleToken = createAction(RewardTokensActions.TOGGLE_TOKEN, pprops<IRewardTokenSelection>());
    static selectSingleToken = createAction(RewardTokensActions.SELECT_SINGLE_TOKEN, pprops<IRewardTokenSelection>());
    static deselectToken = createAction(RewardTokensActions.DESELECT_TOKEN, pprops<IRewardTokenSelection>());
    static deselectTokenForContext = createAction(RewardTokensActions.DESELECT_TOKEN_FOR_CONTEXT, pprops<RewardTokenContext>());
    static deselectAllToken = createAction(RewardTokensActions.DESELECT_ALL_TOKEN, optionalProps<{ trackingSource?: Record<string, string> }>());
    static deselectTokensFromTabSwitch = createAction(RewardTokensActions.DESELECT_TOKENS_FROM_TAB_SWITCH, pprops<ITokenStoreState[]>());
    static openDialog = createAction(
        RewardTokensActions.OPEN_DIALOG,
        props<{
            tokenContext: RewardTokenContext;
            trackingSource?: Record<string, string>;
        }>(),
    );

    static closeDialog = createAction(RewardTokensActions.CLOSE_DIALOG, optionalProps<TokenDialogClosedProps>());
    static clearState = createAction(RewardTokensActions.CLEAR_STATE);
    static showOnboarding = createAction(RewardTokensActions.SHOW_ONBOARDING);
    static hideOnboarding = createAction(RewardTokensActions.HIDE_ONBOARDING);
    static hideAcquisitionOnboarding = createAction(RewardTokensActions.HIDE_ACQUISITION_ONBOARDING);
    static showOverlayInfo = createAction(
        RewardTokensActions.SHOW_OVERLAY_INFO,
        props<{
            tokenContext: RewardTokenContext;
            trackingSource?: Record<string, string>;
            hideTabs?: boolean;
        }>(),
    );

    static overlayTabClicked = createAction(RewardTokensActions.OVERLAY_TAB_CLICKED, pprops<TokenInfoOverlayTabClickedProps>());
    static hideOverlayInfo = createAction(RewardTokensActions.HIDE_OVERLAY_INFO, optionalProps<TokenInfoOverlayHiddenProps>());
    static bannerClick = createAction(RewardTokensActions.BANNER_CLICK, props<{ banner: string; trackingSource?: Record<string, string> }>());
    static refresh = createAction(RewardTokensActions.REFRESH);
    static refreshPostPlacement = createAction(RewardTokensActions.REFRESH_POST_PLACEMENT);
    static betStationClearStorage = createAction(RewardTokensActions.BET_STATION_CLEAR_STORAGE);
    static deselectNonReusableTokens = createAction(RewardTokensActions.DESELECT_NON_REUSABLE_TOKENS);

    static recoverToken = createAction(RewardTokensActions.RECOVER_TOKEN, props<ITokenRecoveryState>());
    static removeRecoverableTokenForContext = createAction(RewardTokensActions.REMOVE_RECOVERABLE_TOKEN_FOR_CONTEXT, props<RewardTokenContext>());
    static clearRecoverableTokens = createAction(RewardTokensActions.CLEAR_RECOVERABLE_TOKENS);
    static checkHasAcquisitionRewardToken = createAction(RewardTokensActions.CHECK_HAS_ACQUISITION_REWARD_TOKEN);
    static autoApplyAcquisitionRewardToken = createAction(RewardTokensActions.AUTO_APPLY_ACQUISITION_REWARD_TOKEN);
    static triggerAccaBoostRefresh = createAction(RewardTokensActions.TRIGGER_ACCABOOST_REFRESH);
}
